module.exports = __webpack_public_path__ + "static/media/28.09f4e32c.jpg";